import { combineReducers } from "redux";

import authenticationReducer from "./authenticationReducer";
import grochatWebsocketReducer from "./grochatWebsocketReducer";

const rootReducer = combineReducers({
    authentication: authenticationReducer,
    grochatWebsocket: grochatWebsocketReducer
})

export default rootReducer;